module.exports = __webpack_public_path__ + "app/principal/billing-address/billing-address-details-2tFOGfYl.html";